import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import dashboardReducer from './dashboardSlice';
import teamReducer from './teamSlice';
import blogReducer from './blogSlice';
import faqReducer from './faqSlice';
import contactReducer from './contactSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    teams: teamReducer,
    blogs: blogReducer,
    faqs: faqReducer,
    contacts: contactReducer,
    dashboard : dashboardReducer,
  },
});
